function Resume() {
  return <h1>Resume Component</h1>;
}

export default Resume;
